import classnames from 'classnames';
import React from 'react';

import { ComparisonOptions } from '../DoubleBarChart';

import styles from './ComparisonColumnChange.module.scss';

export type ComparisonColumnChangeProps = {
  comparisonOptions: ComparisonOptions;
};

const ComparisonColumnChange = ({ comparisonOptions }: ComparisonColumnChangeProps): JSX.Element => {
  const isOddNumber = (index: number): boolean => index % 2 === 1;
  const isBiggerThanZero = (value: string): boolean => value.includes('+');
  const isSmallerThanZero = (value: string): boolean => value.includes('-');
  const displayedValue = (value: string): string => {
    return value || '-';
  };
  const setOpacity = (hoveredRowIndex: number | null, index: number): boolean => {
    return (!!hoveredRowIndex || hoveredRowIndex === 0) && index !== hoveredRowIndex;
  };

  return (
    <div className={styles.ComparisonColumnChange__Container}>
      <div className={styles.ComparisonColumnChange__Header}>{comparisonOptions.title}</div>
      {comparisonOptions.data.map((value, index) => (
        <div
          key={index}
          style={{ height: `${comparisonOptions.rowHeight}px` }}
          className={classnames(styles.ComparisonColumnChange__Text, {
            [styles.ComparisonColumnChange__BackgroundColor]: isOddNumber(index),
            [styles.ComparisonColumnChange__PositiveTextColor]: isBiggerThanZero(value),
            [styles.ComparisonColumnChange__NegativeTextColor]: isSmallerThanZero(value),
            [styles.ComparisonColumnChange__TextOpacity]: setOpacity(comparisonOptions.hoveredRowIndex, index),
          })}
        >
          {displayedValue(value)}
        </div>
      ))}
    </div>
  );
};

export default ComparisonColumnChange;
